var filter = function () {
  return function (input) {
    if (input == null || input == undefined || input == 0) {
      return "Unavailable";
    }
    return (
      {
        retailer: "Manager",
        manager: "Manager",
        retailer_employee: "Employee",
        retailer_admin: "Retailer Admin",
        distributor_admin: "Distributor Admin",
        payments_admin: "Payments Admin",
        sales_rep: "Sales Rep",
        ops_1: "Ops 1",
        ops_2: "Ops 2",
        super_admin: "Super Admin",
        product_manager: "Product Manager",
        group_director: "Group Director",
        finance: "Finance",
      }[input] || input
    );
  };
};

filter.$inject = [];

tiz.filter("roleFilter", filter);
